import { AfterContentInit, Component, ElementRef, OnDestroy, OnInit, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { AppService } from '../services/app.service';
import SignaturePad, { Options, PointGroup } from 'signature_pad';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from '@src/environments/environment';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import {InfoService} from '../services/info.service'

export interface NgSignaturePadOptions extends Options {
  canvasHeight: number;
  canvasWidth: number;
}

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss']
})
export class AgreementComponent implements AfterContentInit, OnDestroy {
  url: any

  file: File

  uploadUrl: any

  signaturePad: SignaturePad;

  options: NgSignaturePadOptions;

  agreementOneResponse: any

  signedBy:string = ''
  listOfPets: any[] = []
  userObj: any
  // @ViewChild('agreementDiv') agreementDiv: HTMLDivElement

  @Output() submitted = new EventEmitter()
  disableBtn: boolean = false;

  constructor(private appService: AppService, private elementRef: ElementRef, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AgreementComponent>, private infoService: InfoService) {
    this.options = this.options || {} as NgSignaturePadOptions;

    if(!this.data.id){
      this.generateId()
    }

    this.listOfPets = this.infoService.listOfPets
    this.userObj = this.infoService.userObj

    if(this.data.subject == 'PET'){
      var find = this.listOfPets.find(pet => pet.petKey == this.data.subjectKey)
      if(find){
        this.data.petNames = find.name
      }
    }
    else{
      this.data.petNames = this.listOfPets.map(pet => pet.name).join(', ')
    }

  }

  submit() {
    if(this.signaturePad.isEmpty()){
      Swal.fire({
        title: 'Agreement Signature',
        html: '<p style="font-size:15px;text-align:center">Please sign the agreement</p>',
        confirmButtonColor: localStorage.getItem('tenantColor'),
      })

      return
    }
    if(this.signedBy == ''){
      Swal.fire({
        title: 'Agreement Signed By Name',
        html: '<p style="font-size:15px;text-align:center">Please enter signed by name</p>',
        confirmButtonColor: localStorage.getItem('tenantColor'),
      })

      return
    }

    let dataURL = this.signaturePad.toDataURL()
    let blob = this.dataURItoBlob(dataURL);
    this.file = new File([blob], 'signature.png', { type: 'image/png' });
    this.agreementOne()
  }

  agreementOne() {
    this.disableBtn = true
    this.appService.newAgreementOne(this.file, this.data.id).subscribe(
      (res: any) => {
        this.agreementOneResponse = res.data
        this.uploadUrl = this.agreementOneResponse.url
        this.agreementThreeOld();
      },

      (err) => {
        this.disableBtn = false

      }
    )
  }

  agreementTwo() {
    this.appService.agreementTwo(this.agreementOneResponse.url, this.file).subscribe(
      (res: any) => {
        this.agreementThreeOld()
      },

      (err) => {
        this.disableBtn = false
      }
    )

  }

  agreementThreeOld() {
    this.appService.agreementThree(this.data.id, this.agreementOneResponse.filename, this.agreementOneResponse.physicalFilename,this.signedBy).subscribe(
      (res: any) => {
        this.disableBtn = false
        this.clearSignaturePad()
        Swal.fire({
          title: 'Agreement Signature',
          html: '<p style="font-size:15px;text-align:center">Your signature has been added successfully</p>',
          confirmButtonColor: localStorage.getItem('tenantColor'),
        })

        this.data.agreementSigned = true

        this.submitted.emit(true)

        this.dialogRef.close()
      },

      (err) => {
        this.disableBtn = false

      }
    )
  }

  agreementThree() {
    let tenant = localStorage.getItem('tenant')
    tenant = tenant.includes('"') ? JSON.parse(tenant) : tenant

    let url = `${environment.agreementThreeUrl}`.replace('{tenantKey}', tenant) + '/' + this.data.id + '?filename=' + this.agreementOneResponse.filename + '&physicalFileName=' + this.agreementOneResponse.physicalFilename + '&uploadType=USER_AGREEMENT&' + 'id=' + this.data.id + '&mimeType=image/png'

    let fetchReq = fetch(url).then(
      (res) => {
        this.disableBtn = false
        if(res && res.status != 200){
          Swal.fire({
            title: 'Agreement Signature',
            html: '<p style="font-size:15px;text-align:center">Something went wrong</p>',
            confirmButtonColor: localStorage.getItem('tenantColor'),
          })

          return
        }

        this.clearSignaturePad()
        Swal.fire({
          title: 'Agreement Signature',
          html: '<p style="font-size:15px;text-align:center">Your signature has been added successfully</p>',
          confirmButtonColor: localStorage.getItem('tenantColor'),
        })

        this.data.agreementSigned = true

        this.submitted.emit(true)

        this.dialogRef.close()
      },

      (err) => {
        this.disableBtn = false
        Swal.fire({
          title: 'Agreement Signature',
          html: '<p style="font-size:15px;text-align:center">Something went wrong</p>',
          confirmButtonColor: localStorage.getItem('tenantColor'),
        })
      }
    )
  }

  dataURItoBlob(dataURI: any) {
    let byteString: any;

    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1]);
    } else {
      byteString = unescape(dataURI.split(',')[1]);
    }

    let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    let ia = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  clearSignaturePad() {
    this.signaturePad.clear()
  }

  generateId(){
   let request =  {
      user: { id: this.data.userId },
      agreement: { id: this.data.agreementId },
      // userAgreementStatus: this.data.status,
      userAgreementStatus: 'REQUESTED',
      subject: this.data.subject,
      subjectKey: this.data.subjectKey
    }

    this.appService.generateIdForAgreement(request, this.data.agreementId).subscribe(
      (res:any) =>{
        if(res.data){
          this.data.id = res.data.id
        }
      },

      (err) =>{
        
      }
    )
  }

  ngAfterContentInit(): void {
    const canvas: HTMLCanvasElement = this.elementRef.nativeElement.querySelector('canvas');
    this.signaturePad = new SignaturePad(canvas, this.options);
  }

  ngOnDestroy(): void {
    const canvas: HTMLCanvasElement = this.elementRef.nativeElement.querySelector('canvas');
    canvas.width = 0;
    canvas.height = 0;
  }
}
